/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2021] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

import _ from 'lodash';

import cleanUpResponse from '@/util/cleanUpResponse';
import { formatDisplayDate } from '@/util/MomentUtils';

export default async function GetAWPackageInformation(awPackageId) {
  const response = await $.soap({
    body: {
      GetAWPackageInformation: {
        $xmlns: 'http://dla.mil/ems/bpm/aw_package',
        AWPackageID: awPackageId
      }
    },
    blueprintArrays: [
      'GetAWPackageInformationResponse.AWPackageContractExtensions.AWPackageContractExtension',
      'GetAWPackageInformationResponse.AWPackageContractExtensionFDRs.AWPackageContractExtensionFDR',
      'GetAWPackageInformationResponse.Commands.Command',
      'GetAWPackageInformationResponse.CRSs.InternalUser',
      'GetAWPackageInformationResponse.TrackerNumbers.CustomerOrder',
      'GetAWPackageInformationResponse.RegionGroups.UserRegionGroup'
    ],
    blueprint: {
      id: '$..AWPackage.ID',
      epcOwner: '$..AWPackage.EPCOwner',
      regionGroupId: '$..AWPackage.RegionGroupID',
      regionOwner: '$..AWPackage.RegionGroup',
      deviceCount: '$..AWPackage.DeviceCount',
      koStatusDateReq: '$..AWPackage.KOStatusDateReq',
      submittedOn: '$..AWPackage.SubmittedOn',
      piinspiin: '$..AWPackage.PIINSPIIN',
      awfdrNum: '$..AWPackage.AWFDRNum',
      vendor: '$..AWPackage.Vendor',
      contractStartDate: '$..AWPackage.ContractStartDate',
      contractEndDate: '$..AWPackage.ContractEndDate',
      isLegacy: '$..IsLegacy',
      fundingSourceId: '$..FundingSourceID',
      awSystemStatus: '$..AWSystemStatus',
      awSystemReason: '$..AWSystemReason',
      awDocumentNum: '$..AWDocumentNum',
      fiscalYear: '$..FiscalYear',
      fundingCenterId: '$..FundingCenterID',
      costCenterId: '$..CostCenterID',
      objectClassId: '$..ObjectClassID',
      internalOrderNumberId: '$..InternalOrderNumberID',
      formName: '$..FormName',
      awPackageContractExtensions: [
        '$..AWPackageContractExtensions.AWPackageContractExtension',
        {
          id: '$.ID',
          piinspiin: '$.PIINSPIIN',
          contractExtensionTypeId: '$.ContractExtensionTypeID',
          extensionEndDate: '$.ExtensionEndDate'
        }
      ],
      awPackageContractExtensionFdrs: [
        '$..AWPackageContractExtensionFDRs.AWPackageContractExtensionFDR',
        {
          id: '$.ID',
          contractExtensionId: '$.ContractExtensionID',
          awfdrNum: '$.AWFDRNum'
        }
      ],
      commands: [
        '$..Commands.Command',
        {
          id: '$.ID',
          commandName: '$.CommandName'
        }
      ],
      crss: [
        '$..CRSs.InternalUser',
        {
          id: '$.ID',
          firstName: '$.FirstName',
          lastName: '$.LastName'
        }
      ],
      regionGroups: [
        '$..RegionGroups.UserRegionGroup',
        {
          id: '$.RegionGroupID',
          name: '$.RegionGroup',
          internalUserID: '$.InternalUserID'
        }
      ],
      trackerNumbers: [
        '$..TrackerNumbers.CustomerOrder',
        {
          name: '$..TrackerNumber'
        }
      ]
    }
  });
  cleanUpResponse(response);

  response.koStatusDateReq = response.koStatusDateReq ? formatDisplayDate(response.koStatusDateReq) : null;
  response.submittedOn = response.submittedOn ? formatDisplayDate(response.submittedOn) : null;
  response.contractStartDate = response.contractStartDate ? formatDisplayDate(response.contractStartDate) : null;
  response.contractEndDate = response.contractEndDate ? formatDisplayDate(response.contractEndDate) : null;

  _.forEach(response.awPackageContractExtensions, (contractExtension) => {
    contractExtension.awPackageContractExtensionFdrs = _.filter(response.awPackageContractExtensionFdrs, {
      contractExtensionId: contractExtension.id
    });
    contractExtension.extensionEndDate = contractExtension.extensionEndDate
      ? formatDisplayDate(contractExtension.extensionEndDate)
      : null;
  });

  _.forEach(response.crss, (crs) => {
    crs.name = `${crs.firstName} ${crs.lastName}`;
  });

  // Remove "All" Dropdown Option for Region Groups
  response.regionGroups = _.reject(response.regionGroups, {
    id: '4'
  });

  return response;
}
